import {AbstractModel} from '../abstract-model';

export class PartnerDetails extends AbstractModel {
  bankAccountHolder: string | null = null;
  bankAddress: string | null = null;
  bankName: string | null = null;
  companyAddress: string | null = null;
  companyCity: string | null = null;
  companyCountry: string | null = null;
  companyName: string | null = null;
  companyRegistrationNumber: string | null = null;
  companyState: string | null = null;
  companyVatNumber: string | null = null;
  companyZipCode: string | null = null;
  contactEmail: string | null = null;
  iban: string | null = null;
  routingNumber: string | null = null;
  swift: string | null = null;
}
